import type { RoutesTreeItem } from 'containers/App/Routes/RoutesTreeItem';

import { BackupMaintenancePage } from 'pages/Settings/System/BackupMaintenance/BackupMaintenancePage';
import CertificationAuthoritiesPage from 'pages/Settings/System/BackupMaintenance/CertificationAuthorities';
import { IpfCertificate } from './IpfCertificate/IpfCertificate';
import { IpfCertificateUpload } from './IpfCertificateUpload/IpfCertificateUpload';
import SnmpPage from './Snmp/Snmp';

export const systemRoutes: RoutesTreeItem[] = [
  {
    path: '/settings/system/snmp',
    element: <SnmpPage />,
    requiredApiScope: { method: 'GET', path: '/settings' },
  },
  {
    path: '/settings/system/ipfabric-certificates',
    element: <IpfCertificate />,
    requiredApiScope: { method: 'GET', path: '/os/hostname' },
  },
  {
    path: '/settings/system/ipfabric-certificates-upload',
    element: <IpfCertificateUpload />,
  },
  {
    path: '/settings/system/backup-maintenance',
    element: <BackupMaintenancePage />,
    requiredApiScope: {
      or: [
        // See backup and maintenance schedule
        { method: 'GET', path: '/settings' },
        // Clean database
        { method: 'POST', path: '/os/clean-db' },
        // Start maintenance now
        { method: 'POST', path: '/os/maintenance' },
        // Import configuration
        { method: 'POST', path: '/appliance-configuration/import' },
        // Export configuration
        { method: 'POST', path: '/appliance-configuration/export' },
      ],
    },
  },
  {
    path: '/settings/system/certificate-authorities',
    element: <CertificationAuthoritiesPage />,
    requiredApiScope: { method: 'GET', path: '/settings/ca' },
  },
];
